import React from 'react';
import Footer from '../shared/Footer/Footer';
import OtherNav from '../shared/Navbar/Other/OtherNav';

const ErrorPage = () => {
    return (
        <div>
            <OtherNav></OtherNav>
            <div className='flex flex-col justify-center items-center min-h-[63.2vh]'>
                <h3 className='text-red-500 font-bold text-2xl'>404</h3>
                <p className='font-bold mx-3 text-center'>Ooh No! Your searching page is not found</p>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default ErrorPage;